// Browser-side Supabase client. Safe to ship to the frontend — uses the anon key,
// which is constrained by RLS at the database level.
//
// Env vars are read via import.meta.env.VITE_* — Vite inlines those
// references at build time and exposes any VITE_* vars on import.meta.env.
// Drop a `.env` next to package.json (gitignored) and Vite loads it
// automatically.

import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/types/db";

const url     = import.meta.env.VITE_SUPABASE_URL     ?? "";
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? "";
const siteUrl = import.meta.env.VITE_SITE_URL         ?? "";
const cbPath  = import.meta.env.VITE_AUTH_REDIRECT_PATH ?? "/auth/callback";

if (!url || !anonKey) {
  console.warn(
    "[supabase] VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set. " +
    "Copy .env.example to .env and fill in the values."
  );
}

export const supabase: SupabaseClient<Database> = createClient<Database>(url, anonKey, {
  auth: {
    persistSession:    true,
    autoRefreshToken:  true,
    detectSessionInUrl: true,
    storage:           typeof window === "undefined" ? undefined : window.localStorage,
    storageKey:        "famchest.auth",
    flowType:          "pkce",
  },
});

/** URL the OAuth provider redirects back to. */
export const authRedirectTo =
  (siteUrl || (typeof window !== "undefined" ? window.location.origin : "")) +
  (cbPath || "/auth/callback");

export const isAuthConfigured = (): boolean => Boolean(url) && Boolean(anonKey);
